import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="administration--tableau-filter"
// Expands/collapses project details based on selected views and tracks loading progress
export default class extends Controller {
  static targets = [
    "toggle",
    "progressContainer",
    "progressText",
    "progressBar",
  ];
  static values = { total: Number };

  connect() {
    this.loadedCount = 0;

    // Listen for turbo frame loads to apply filter to newly loaded content
    this.frameLoadHandler = this.onFrameLoad.bind(this);
    this.element.addEventListener("turbo:frame-load", this.frameLoadHandler);
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.frameLoadHandler);
  }

  onFrameLoad(event) {
    // Track loading progress
    this.loadedCount++;
    this.updateProgress();

    // When a frame loads, apply current filter state
    if (this.hasToggleTarget && this.toggleTarget.checked) {
      const frame = event.target;
      const details = frame.querySelector("details");
      if (details) {
        const hasChecked = details.querySelector(
          "input[type='checkbox']:checked",
        );
        if (hasChecked) {
          details.open = true;
        }
      }
    }
  }

  updateProgress() {
    const total = this.totalValue;
    const loaded = this.loadedCount;
    const percentage = total > 0 ? Math.round((loaded / total) * 100) : 0;

    // Update progress bar width
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percentage}%`;
    }

    // Update progress text
    if (this.hasProgressTextTarget) {
      if (loaded >= total) {
        this.progressTextTarget.textContent =
          this.element.dataset.allLoadedText || "Alle Projekte geladen";
      } else {
        const template =
          this.element.dataset.loadingTextTemplate ||
          "{loaded}/{total} Projekte geladen";
        this.progressTextTarget.textContent = template
          .replace("{loaded}", loaded)
          .replace("{total}", total);
      }
    }

    // Hide progress container when all loaded (with delay)
    if (loaded >= total && this.hasProgressContainerTarget) {
      setTimeout(() => {
        this.progressContainerTarget.style.display = "none";
      }, 1500);
    }
  }

  filter(event) {
    if (event.target.checked) {
      this.expandSelected();
    } else {
      this.collapseAll();
    }
  }

  expandSelected() {
    this.element.querySelectorAll("details").forEach((details) => {
      const hasChecked = details.querySelector(
        "input[type='checkbox']:checked",
      );
      if (hasChecked) {
        details.open = true;
      }
    });
  }

  collapseAll() {
    this.element.querySelectorAll("details").forEach((details) => {
      details.open = false;
    });
  }
}
